import { $, $$, tap } from './utils';

tap($('user-kind-filter'), (cntr) => {
  const inputs = [...cntr.querySelectorAll('input')];

  cntr.addEventListener('change', (ev) => {
    const el = ev.target.closest('input');
    if (!el) return;
    if (el.value === 'ALL') inputs.forEach((input) => (input.checked = true));
    updateKindFilters();
  });

  function updateKindFilters() {
    const every = inputs.every((input) => input.checked);
    inputs.find((input) => input.value === 'ALL').checked = every;
    const checked = inputs.filter((input) => input.checked).map((input) => input.value);
    [...$('users-table').children].forEach((tr) => (tr.hidden = !checked.includes(tr.dataset.kind)));
    sessionStorage.setItem('user-kinds', JSON.stringify(checked));
  }

  const sessChecked = JSON.parse(sessionStorage.getItem('user-kinds') || '[]');
  if (sessChecked.length) {
    inputs.forEach((input) => (input.checked = sessChecked.includes(input.value)));
  }
  updateKindFilters();
});

const update = () => $$('#user-kinds td:first-child').forEach((elem, i) => (elem.textContent = `${i + 1}`));

$('user_kinds_table')?.addEventListener('click', (ev) => {
  const target = ev.target;
  const tr = target.closest('tr');

  if (target.closest('.moveup-user-kind')) {
    const prev = tr?.previousElementSibling;
    if (prev) tr.parentElement.insertBefore(tr, prev);
    update();
  } else if (target.closest('.movedn-user-kind')) {
    const next = tr?.nextElementSibling;
    if (next) tr.parentElement.insertBefore(tr, next.nextElementSibling);
    update();
  } else if (target.closest('.remove-user-kind')) {
    tr?.remove();
    update();
  }
});
$('add-user-kind')?.addEventListener('click', () => {
  const name = `NEW${Date.now()}`;
  const html = $('template-user-kind').innerHTML.replace(/NEWID/g, name);
  $('user-kinds').insertAdjacentHTML('beforeend', html);
  update();
});
